// These are public browser-tag identifiers supplied by G2 Digital Markets.
const vendorId = process.env.GATSBY_G2DM_VENDOR_ID || "";
const vendorKey = process.env.GATSBY_G2DM_VENDOR_KEY || "";

export const initializeG2DigitalMarkets = () => {
  if (
    typeof window === "undefined" ||
    typeof document === "undefined" ||
    process.env.NODE_ENV !== "production" ||
    !["salesbinder.com", "www.salesbinder.com"].includes(
      window.location.hostname,
    ) ||
    !/^[a-f0-9]{8}-(?:[a-f0-9]{4}-){3}[a-f0-9]{12}$/i.test(vendorId) ||
    !/^[a-f0-9]{32}$/i.test(vendorKey) ||
    document.getElementById("g2-digital-markets-tag")
  ) {
    return;
  }

  window._ct = {
    vid: vendorId,
    vkey: vendorKey,
    uc: true,
    hasDoNotTrackIPs: false,
  };
  window.gdmEvents = Array.isArray(window.gdmEvents) ? window.gdmEvents : [];
  const script = document.createElement("script");
  script.id = "g2-digital-markets-tag";
  script.async = true;
  script.src = "https://tr.capterra.com/static/wp.js";
  document.head.appendChild(script);
};
